import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1185.94118,-2.5243549e-29 C1259.46588,-2.5243549e-29 1321.58353,47.3223529 1344.96235,112.941176 L1344.96235,112.941176 L1807.11765,112.941176 L1807.11765,1920 L113,1920 L113,112.941176 L575.155294,112.941176 C598.534118,47.3223529 660.651765,-2.5243549e-29 734.176471,-2.5243549e-29 L734.176471,-2.5243549e-29 Z M1242.41176,1468.23529 L903.588235,1468.23529 L903.588235,1581.17647 L1242.41176,1581.17647 L1242.41176,1468.23529 Z M790.647059,1242.35294 L451.823529,1242.35294 L451.823529,1581.17647 L790.647059,1581.17647 L790.647059,1242.35294 Z M1468.29412,1242.35294 L903.588235,1242.35294 L903.588235,1355.29412 L1468.29412,1355.29412 L1468.29412,1242.35294 Z M790.647059,677.647059 L451.823529,677.647059 L451.823529,1016.47059 L790.647059,1016.47059 L790.647059,677.647059 Z M1242.41176,903.529412 L903.588235,903.529412 L903.588235,1016.47059 L1242.41176,1016.47059 L1242.41176,903.529412 Z M1468.29412,677.647059 L903.588235,677.647059 L903.588235,790.588235 L1468.29412,790.588235 L1468.29412,677.647059 Z M1185.94118,112.941176 L734.176471,112.941176 C703.117647,112.941176 677.705882,138.24 677.705882,169.411765 L677.705882,169.411765 L677.705882,338.823529 L1242.41176,338.823529 L1242.41176,169.411765 C1242.41176,138.24 1217,112.941176 1185.94118,112.941176 L1185.94118,112.941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRubricSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconRubricSolid, _Component);

  var _super = _createSuper(IconRubricSolid);

  function IconRubricSolid() {
    _classCallCheck(this, IconRubricSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconRubricSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRubric",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconRubricSolid.displayName = "IconRubricSolid";
  return IconRubricSolid;
}(Component);

IconRubricSolid.glyphName = 'rubric';
IconRubricSolid.variant = 'Solid';
IconRubricSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRubricSolid;
export { IconRubricSolid };